import * as React from 'react';

const HtmlPreviewFrame = ({ html, minHeight = 1200, title = 'HTML Preview', onMessage = null }) => {
  if (!html) return null;

  const iframeRef = React.useRef(null);

  React.useEffect(() => {
    const handler = (e) => {
      if (typeof onMessage === 'function') {
        try { onMessage(e.data, e); } catch (_) {}
      }
      if (e.data?.type === 'rovo-copy' && e.data?.text) {
        navigator.clipboard.writeText(e.data.text).catch(() => {});
      }
      // Resize iframe to content height to avoid double scrollbars
      if (e.data?.type === 'rovo-height' && e.data?.height && iframeRef.current) {
        iframeRef.current.style.height = e.data.height + 'px';
      }
    };
    window.addEventListener('message', handler);
    return () => window.removeEventListener('message', handler);
  }, [onMessage]);

  return (
    <div
      style={{
        width: '100%',
        background: '#F4F5F7',
        border: '1px solid #DFE1E6',
        borderRadius: 8,
        overflow: 'hidden',
        boxShadow: '0 1px 3px rgba(9,30,66,0.08)',
      }}
    >
      <iframe
        ref={iframeRef}
        title={title}
        srcDoc={html}
        style={{
          width: '100%',
          minHeight,
          border: 'none',
          display: 'block',
          background: '#FFFFFF',
          overflow: 'hidden',
        }}
        sandbox="allow-same-origin allow-scripts"
        scrolling="no"
        onLoad={(e) => {
          try {
            const doc = e.target.contentDocument || e.target.contentWindow?.document;
            if (doc) {
              const resize = () => {
                const h = doc.documentElement.scrollHeight || doc.body.scrollHeight;
                if (h > 0) e.target.style.height = h + 'px';
              };
              resize();
              new e.target.contentWindow.ResizeObserver(resize).observe(doc.body);

              // srcDoc opportunity actions are same-origin in this sandbox. Bridge
              // them directly as well as via postMessage so navigation is reliable
              // across Forge/browser combinations.
              if (typeof onMessage === 'function' && !doc.__metricusOpportunityBridgeInstalled) {
                doc.__metricusOpportunityBridgeInstalled = true;
                doc.addEventListener('click', (event) => {
                  try {
                    const actionButton = event.target?.closest?.('[data-opp-action]');
                    if (!actionButton) return;
                    event.preventDefault();
                    const idx = Number(actionButton.getAttribute('data-opp-index'));
                    const action = actionButton.getAttribute('data-opp-action');
                    const dataEl = doc.getElementById('__qa_data__');
                    const data = dataEl ? JSON.parse(dataEl.textContent || '{}') : {};
                    const opportunity = (data.opportunities || [])[idx];
                    if (opportunity) onMessage({ type: 'metricus-opportunity-action', action, opportunity });
                  } catch (_) {}
                });
              }
            }
          } catch (_) {}
        }}
      />
    </div>
  );
};

export default HtmlPreviewFrame;
